import { queryOptions } from "@tanstack/react-query";
const cashAppLocal = {
  keys: {
    root: () => ["cashAppLocal"],
    brand: () => [...cashAppLocal.keys.root(), "brand"],
    onboarding: () => [...cashAppLocal.keys.root(), "onboarding"],
    qrCodes: () => [...cashAppLocal.keys.root(), "qr-codes"],
    metrics: () => [...cashAppLocal.keys.root(), "metrics"],
    meetingDetails: () => [...cashAppLocal.keys.root(), "meetingDetails"],
    pauseSurvey: () => [...cashAppLocal.keys.root(), "pauseSurvey"],
    neighborhoodsEnrollments: () => [...cashAppLocal.keys.root(), "neighborhoodsEnrollments"],
    geoSellers: () => [...cashAppLocal.keys.root(), "geoSellers"]
  },
  // Queries
  defaultBrand: (params = {}) => queryOptions({
    queryKey: [...cashAppLocal.keys.brand(), params],
    queryFn: async () => {
      const { getMerchantDefaultBrand } = await import("../api/cash-app-local/rpc.js");
      return getMerchantDefaultBrand(params);
    }
  }),
  totalLocalCashEarned: (params = {}) => queryOptions({
    queryKey: [...cashAppLocal.keys.metrics(), "totalLocalCashEarned", params],
    queryFn: async () => {
      const { getMerchantTotalLocalCashEarned } = await import("../api/cash-app-local/rpc.js");
      return getMerchantTotalLocalCashEarned(params);
    }
  }),
  totalLocalCashRedeemed: (params = {}) => queryOptions({
    queryKey: [...cashAppLocal.keys.metrics(), "totalLocalCashRedeemed", params],
    queryFn: async () => {
      const { getMerchantTotalLocalCashRedeemed } = await import("../api/cash-app-local/rpc.js");
      return getMerchantTotalLocalCashRedeemed(params);
    }
  }),
  getMostFrequentItems: (params = {}) => queryOptions({
    queryKey: [...cashAppLocal.keys.metrics(), "mostFrequentItems", params],
    queryFn: async () => {
      const { getMostFrequentItems } = await import("../api/cash-app-local/rpc.js");
      return getMostFrequentItems(params);
    },
    retry: false
  }),
  followersAgeDemographics: (params = {}) => queryOptions({
    queryKey: [...cashAppLocal.keys.metrics(), "followersAgeDemographics", params],
    queryFn: async () => {
      const { getFollowersAgeDemographics } = await import("../api/cash-app-local/rpc.js");
      return getFollowersAgeDemographics(params);
    }
  }),
  // Mutations
  updateTippingConfiguration: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "updateTippingConfiguration"],
    mutationFn: async (params) => {
      const { setBrandTippingConfiguration } = await import("../api/cash-app-local/rpc.js");
      return setBrandTippingConfiguration(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  updateTrackingSettings: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "updateTrackingSettings"],
    mutationFn: async (params) => {
      const { setBrandTrackingSettings } = await import("../api/cash-app-local/rpc.js");
      return setBrandTrackingSettings(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  updateOrderingConfiguration: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "updateOrderingConfiguration"],
    mutationFn: async (params) => {
      const { setBrandOrderingConfiguration } = await import("../api/cash-app-local/rpc.js");
      return setBrandOrderingConfiguration(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  updateCheckoutNotes: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "updateCheckoutNotes"],
    mutationFn: async (params) => {
      const { setBrandCheckoutNotes } = await import("../api/cash-app-local/rpc.js");
      return setBrandCheckoutNotes(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  updateCheckoutSecurity: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "updateCheckoutSecurity"],
    mutationFn: async (params) => {
      const { setBrandCheckoutSecurity } = await import("../api/cash-app-local/rpc.js");
      return setBrandCheckoutSecurity(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  setBrandDescription: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "setBrandDescription"],
    mutationFn: async (params) => {
      const { setBrandDescription } = await import("../api/cash-app-local/rpc.js");
      return setBrandDescription(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  setBrandName: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "setBrandName"],
    mutationFn: async (params) => {
      const { setBrandName } = await import("../api/cash-app-local/rpc.js");
      return setBrandName(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  setBrandColor: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "setBrandColor"],
    mutationFn: async (params) => {
      const { setBrandColor } = await import("../api/cash-app-local/rpc.js");
      return setBrandColor(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  setBrandCashtag: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "setBrandCashtag"],
    mutationFn: async (params) => {
      const { setBrandCashtag } = await import("../api/cash-app-local/rpc.js");
      return setBrandCashtag(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  getSquareSellerOnboardingStatus: (params = {}) => queryOptions({
    queryKey: [...cashAppLocal.keys.onboarding(), "getSquareSellerOnboardingStatus", params],
    queryFn: async () => {
      const { getSquareSellerOnboardingStatus } = await import("../api/cash-app-local/rpc.js");
      return getSquareSellerOnboardingStatus(params);
    }
  }),
  requestSquareSellerOnboarding: () => ({
    mutationKey: [...cashAppLocal.keys.onboarding(), "requestSquareSellerOnboarding"],
    mutationFn: async (params) => {
      const { requestSquareSellerOnboarding } = await import("../api/cash-app-local/rpc.js");
      return requestSquareSellerOnboarding(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.onboarding()]
    }
  }),
  onboardSquareMerchant: () => ({
    mutationKey: [...cashAppLocal.keys.onboarding(), "onboardSquareMerchant"],
    mutationFn: async (params = {}) => {
      const { onboardSquareMerchant } = await import("../api/cash-app-local/rpc.js");
      return onboardSquareMerchant(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand(), cashAppLocal.keys.onboarding()]
    }
  }),
  setMenuAssignment: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "setMenuAssignment"],
    mutationFn: async (params) => {
      const { setMenuAssignment } = await import("../api/cash-app-local/rpc.js");
      return setMenuAssignment(params);
    }
  }),
  listQrOrderingData: (params = {}) => queryOptions({
    queryKey: [...cashAppLocal.keys.qrCodes(), "listQrOrderingData", params],
    queryFn: async () => {
      const { listQrOrderingData } = await import("../api/cash-app-local/rpc.js");
      return listQrOrderingData(params);
    },
    enabled: Boolean(params?.unitTokens?.length)
  }),
  printLocationQrCode: () => ({
    mutationKey: [...cashAppLocal.keys.qrCodes(), "printLocationQrCode"],
    mutationFn: async (params) => {
      const { printLocationQrCode } = await import("../api/cash-app-local/rpc.js");
      return printLocationQrCode(params);
    }
  }),
  printQrCodes: () => ({
    mutationKey: [...cashAppLocal.keys.qrCodes(), "printQrCodes"],
    mutationFn: async (params) => {
      const { printQrCodes } = await import("../api/cash-app-local/rpc.js");
      return printQrCodes(params);
    }
  }),
  getNeighborhoodMeetingDetails: (params = {}) => queryOptions({
    queryKey: [...cashAppLocal.keys.meetingDetails(), "getNeighborhoodMeetingDetails", params],
    queryFn: async () => {
      const { getNeighborhoodMeetingDetails } = await import("../api/cash-app-local/rpc.js");
      return getNeighborhoodMeetingDetails(params);
    }
  }),
  saveNeighborhoodMeetingDetails: () => ({
    mutationKey: [...cashAppLocal.keys.meetingDetails(), "saveNeighborhoodMeetingDetails"],
    mutationFn: async (params) => {
      const { saveNeighborhoodMeetingDetails } = await import("../api/cash-app-local/rpc.js");
      return saveNeighborhoodMeetingDetails(params);
    }
    // Note: No auto-invalidation here. Invalidation is handled conditionally
    // in useMeetingDetails hook to prevent race conditions on initial bookings.
  }),
  setBrandPolicies: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "setBrandPolicies"],
    mutationFn: async (params) => {
      const { setBrandPolicies } = await import("../api/cash-app-local/rpc.js");
      return setBrandPolicies(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  setBrandCard: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "setBrandCard"],
    mutationFn: async (params) => {
      const { setBrandCard } = await import("../api/cash-app-local/rpc.js");
      return setBrandCard(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand()]
    }
  }),
  uploadBrandLogoImage: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "uploadBrandLogoImage"],
    mutationFn: async (params) => {
      const { uploadBrandLogoImage } = await import("../api/cash-app-local/rpc.js");
      return uploadBrandLogoImage(params);
    }
  }),
  pauseNeighborhoodProgram: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "pauseNeighborhoodProgram"],
    mutationFn: async (params = {}) => {
      const { pauseNeighborhoodProgram } = await import("../api/cash-app-local/rpc.js");
      return pauseNeighborhoodProgram(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand(), cashAppLocal.keys.neighborhoodsEnrollments()]
    }
  }),
  unpauseNeighborhoodProgram: () => ({
    mutationKey: [...cashAppLocal.keys.brand(), "unpauseNeighborhoodProgram"],
    mutationFn: async (params = {}) => {
      const { unpauseNeighborhoodProgram } = await import("../api/cash-app-local/rpc.js");
      return unpauseNeighborhoodProgram(params);
    },
    meta: {
      invalidates: [cashAppLocal.keys.brand(), cashAppLocal.keys.neighborhoodsEnrollments()]
    }
  }),
  saveNeighborhoodPauseSurvey: () => ({
    mutationKey: [...cashAppLocal.keys.pauseSurvey(), "saveNeighborhoodPauseSurvey"],
    mutationFn: async (params) => {
      const { saveNeighborhoodPauseSurvey } = await import("../api/cash-app-local/rpc.js");
      return saveNeighborhoodPauseSurvey(params);
    }
  }),
  getMerchantNeighborhoodsEnrollments: (params = {}) => queryOptions({
    queryKey: [...cashAppLocal.keys.neighborhoodsEnrollments(), params],
    queryFn: async () => {
      const { getMerchantNeighborhoodsEnrollments } = await import("../api/cash-app-local/rpc.js");
      return getMerchantNeighborhoodsEnrollments(params);
    }
  }),
  getGeoSellers: (params) => queryOptions({
    queryKey: [...cashAppLocal.keys.geoSellers(), params],
    queryFn: async () => {
      const { getGeoSellers } = await import("../api/cash-app-local/rpc.js");
      return getGeoSellers(params);
    },
    enabled: Boolean(params?.geoToken)
  })
};
export {
  cashAppLocal
};
//# sourceMappingURL=cash-app-local.js.map
